"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentLocation = exports.useGetNearestBranchesMutation = exports.useGetAllBranchesQuery = exports.branchesApi = void 0;
// api/branchesApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
// Custom base query for Sky Lifestyle API with Bearer token
var branchesBaseQuery = (0, react_1.fetchBaseQuery)({
    baseUrl: process.env.LETS_TRADE_CLIENT_URL,
    prepareHeaders: function (headers) {
        var token = process.env.LETS_TRADE_CLIENT_TOKEN;
        if (token) {
            headers.set("Authorization", "Bearer ".concat(token));
        }
        headers.set("Content-Type", "application/json");
        return headers;
    },
});
exports.branchesApi = (0, react_1.createApi)({
    reducerPath: "branchesApi",
    baseQuery: branchesBaseQuery,
    tagTypes: ["branches"],
    endpoints: function (builder) { return ({
        getAllBranches: builder.query({
            query: function () { return ({
                url: "/v2/client/branches",
                method: "GET",
            }); },
            providesTags: ["branches"],
        }),
        getNearestBranches: builder.mutation({
            query: function (request) { return ({
                url: "/v2/get/nearest/branches",
                method: "POST",
                body: request,
            }); },
            invalidatesTags: ["branches"],
        }),
    }); },
});
exports.useGetAllBranchesQuery = exports.branchesApi.useGetAllBranchesQuery, exports.useGetNearestBranchesMutation = exports.branchesApi.useGetNearestBranchesMutation;
// Utility function for getting user's current location (non-RTK Query)
var getCurrentLocation = function () {
    return new Promise(function (resolve) {
        if (!navigator.geolocation) {
            resolve(null);
            return;
        }
        navigator.geolocation.getCurrentPosition(function (position) {
            resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            });
        }, function (error) {
            console.error("Geolocation error:", error);
            resolve(null);
        });
    });
};
exports.getCurrentLocation = getCurrentLocation;
